import { createContext } from 'react';

import {
  CategorizationConfiguration,
  CategorizationCreateRequirements,
  CategorizationNodeLocation,
  CategorizationValidationError,
  EditableCategorizationNode,
  OrganizationReference,
} from '@totem/components/ticketing/categorizationManagement/types';

interface Context {
  loading: boolean;
  saving: boolean;
  configuration: CategorizationConfiguration | null;
  nodes: EditableCategorizationNode[];
  organizations: OrganizationReference[];
  securityGroupOptions: string[];
  selectedKey: string | null;
  selected: CategorizationNodeLocation | null;
  isDirty: boolean;
  validationErrors: CategorizationValidationError[];
  setSelectedKey: (key: string | null) => void;
  onAddNode: (parentKey: string | null) => void;
  onRenameNode: (key: string, name: string) => void;
  onUpdateRequirements: (
    key: string,
    requirements: Partial<CategorizationCreateRequirements>,
  ) => void;
  onRemoveNode: (key: string) => void;
  onMoveNode: (key: string, offset: number) => void;
  onSave: () => void;
  onDiscard: () => void;
  onRefresh: () => void;
}

export default createContext<Context>({
  loading: false,
  saving: false,
  configuration: null,
  nodes: [],
  organizations: [],
  securityGroupOptions: [],
  selectedKey: null,
  selected: null,
  isDirty: false,
  validationErrors: [],
  setSelectedKey: () => {},
  onAddNode: () => {},
  onRenameNode: () => {},
  onUpdateRequirements: () => {},
  onRemoveNode: () => {},
  onMoveNode: () => {},
  onSave: () => {},
  onDiscard: () => {},
  onRefresh: () => {},
});
